module.exports = __webpack_public_path__ + "static/media/taco-3.dd2ad269.jpg";